import { Injectable } from '@angular/core';
import { default as marked } from 'marked';
export class MarkedConfigClass {
    constructor() {
        this.options = {
            gfm: true,
            tables: true,
            breaks: true,
            pedantic: false,
            sanitize: false,
            smartLists: true,
            smartypants: false
        };
        this.loadingTemplate = `<div>Loading ...</div>`;
    }
}
export class MarkdownService {
    constructor(config) {
        this.config = config;
    }
    marked(string, options, callback) {
        return new Promise((resolve, reject) => {
            marked(string, (options) ? options : this.config[0].options, (error, result) => {
                if (error) {
                    reject(error);
                }
                else {
                    resolve(result);
                }
                if (callback) {
                    callback(error, result);
                }
            });
        });
    }
}
MarkdownService.decorators = [
    { type: Injectable },
];
MarkdownService.ctorParameters = () => [
    { type: MarkedConfigClass, },
];
//# sourceMappingURL=ngx-markdown.service.js.map